/** Legacy `<!-- zw-indent -->` wrapper lines (pre-`.zwdoc`; read-only). */

export const INDENT_OPEN = /^<!--\s*zw-indent:\s*(\d+)\s*-->\s*$/i;
export const INDENT_CLOSE = /^<!--\s*\/zw-indent\s*-->\s*$/i;

export const MAX_INDENT_LEVEL = 6;

export function parseIndentOpen(text: string): number | null {
  const match = INDENT_OPEN.exec(text.trim());
  const captured = match?.[1];
  if (captured === undefined) return null;
  const level = Number.parseInt(captured, 10);
  if (!Number.isFinite(level) || level < 1) return null;
  return Math.min(level, MAX_INDENT_LEVEL);
}

export function isIndentClose(text: string): boolean {
  return INDENT_CLOSE.test(text.trim());
}

export function isIndentMarkerLine(text: string): boolean {
  return parseIndentOpen(text) !== null || isIndentClose(text);
}
